
import { call, put, takeEvery } from "redux-saga/effects";
import { keHoachMonApi } from "../../../api/ke-hoach/keHoachMonApi";
import { keHoachMonGhepCapApi } from "../../../api/ke-hoach/keHoachMonGhepCapApi";
import { IKeHoachMonGhepCapSelectRequest } from "../../../model/request/ke-hoach/IKeHoachMonGhepCapSelectRequest";
import { IKeHoachMonSelectRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IKeHoachMonGhepCap } from "../../../model/respone/ke-hoach/IKeHoachMonGhepCap";
import { eKeHoachMonGhepCapActionIds, IKeHoachMonGhepCapActionTypes } from "../../action-types/ke-hoach/IKeHoachMonGhepCapActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.keHoach.ghepCap;
export function* ghepCapSaga(): any {
    yield takeEvery(eKeHoachMonGhepCapActionIds.LOAD_START, loadWorker)
    yield takeEvery(eKeHoachMonGhepCapActionIds.LOAD_KE_HOACH_MON_START, loadKeHoachMonWorker)
    yield takeEvery(eKeHoachMonGhepCapActionIds.SAVE_START, saveWorker)
    // yield takeEvery(eKeHoachMonGhepCapActionIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IKeHoachMonGhepCapActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonGhepCapApi.SelectByNamHoc, action.payload as IKeHoachMonGhepCapSelectRequest)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}
function* loadKeHoachMonWorker(action: IKeHoachMonGhepCapActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.Select, action.payload as IKeHoachMonSelectRequest)
    if (res.is_success) {
        yield put(mainAction.LOAD_KE_HOACH_MON_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: IKeHoachMonGhepCapActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonGhepCapApi.Saves, action.payload as IKeHoachMonGhepCap[])
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}


// function* saveWorker(action: IKeHoachMonGhepCapActionTypes): any {
//     let res: IBaseRespone;
//     const payload = action.payload as IKeHoachMonGhepCap
//     if (payload.id > 0) {
//         res = yield call(giaiDoanApi.Update, payload)
//     } else {
//         res = yield call(giaiDoanApi.Insert, payload)
//     }
//     if (res.is_success) {
//         yield put(mainAction.SAVE_SUCCESS(res.data))
//     } else {
//         yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
//     }
// }

// function* deleteWorker(action: IKeHoachMonGhepCapActionTypes): any {
//     const res: IBaseRespone = yield call(giaiDoanApi.Delete, action.payload as number)
//     if (res.is_success) {
//         yield put(mainAction.DELETE_SUCCESS(res.data))
//     } else {
//         yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
//     }
// }